// e561c71c84520e04e36e4ce9b1e8000a0527df6f|className=ChatSessionApi|type=angular|apiName=agent|apiEnumKey=Agent|operationHash=e521bfe65c0229c077e059ff5e8e4ad0393c6a2f|kind=api-js

import * as i0 from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Api } from '@myre/common-conf';
import {
  DynamicEnvService,
  AngularSdk,
} from '@myre/ui-domain-http';
import { parseOkResponseFromJSON } from '../../../parsers/OkResponse';

import { parseChatMessageFromJSON } from '../../../parsers/ChatMessage';
import { parseChatMessageRatingToJSON } from '../../../parsers/ChatMessageRating';
import { parseChatSessionFromJSON } from '../../../parsers/ChatSession';
import { parseChatSessionUpdateToJSON } from '../../../parsers/ChatSessionUpdate';

export class ChatSessionApi extends AngularSdk {
  constructor(
    dynamicEnvService,
    httpClient,
  ) {
    super(dynamicEnvService, httpClient);
  }

  /**
   * @description <p>🔐 Auth</p><p>🛡 CustomerAuth</p><p>🛡 ChatAccessAuth</p>
   *
   * @tags ChatSessionApi
   * @name ChatSessionApiGetChatSessions
   * @summary List chat sessions
   * @request GET:/customers/{customerId}/chat-sessions
   * @secure
   */
  getChatSessions(
    {
      customerId,
    },
    requestOptions = {},
  ) {
    return this._request(
      {
        path: `/customers/${customerId}/chat-sessions`,
        route: '/customers/{customerId}/chat-sessions',
        method: 'GET',
        api: Api.Agent,
      },
      {
        ...requestOptions,
        parser: data => parseOkResponseFromJSON(data, {
    contentParser: parseChatSessionFromJSON,
    isContentArray: true,
  }),
      },
    );
  }

  /**
   * @description <p>🔐 Auth</p><p>🛡 CustomerAuth</p><p>🛡 ChatAccessAuth</p>
   *
   * @tags ChatSessionApi
   * @name ChatSessionApiGetChatSession
   * @summary Get a chat session
   * @request GET:/customers/{customerId}/chat-sessions/{sessionId}
   * @secure
   */
  getChatSession(
    {
      customerId,
      sessionId,
    },
    requestOptions = {},
  ) {
    return this._request(
      {
        path: `/customers/${customerId}/chat-sessions/${sessionId}`,
        route: '/customers/{customerId}/chat-sessions/{sessionId}',
        method: 'GET',
        api: Api.Agent,
      },
      {
        ...requestOptions,
        parser: data => parseOkResponseFromJSON(data, {
    contentParser: parseChatSessionFromJSON,
    isContentArray: false,
  }),
      },
    );
  }

  /**
   * @description <p>🔐 Auth</p><p>🛡 CustomerAuth</p><p>🛡 ChatAccessAuth</p>
   *
   * @tags ChatSessionApi
   * @name ChatSessionApiUpdateChatSession
   * @summary Update a chat session
   * @request PUT:/customers/{customerId}/chat-sessions/{sessionId}
   * @secure
   */
  updateChatSession(
    {
      customerId,
      sessionId,
    },
    data,
    requestOptions = {},
  ) {
    return this._request(
      {
        path: `/customers/${customerId}/chat-sessions/${sessionId}`,
        route: '/customers/{customerId}/chat-sessions/{sessionId}',
        method: 'PUT',
        body: parseChatSessionUpdateToJSON(data),
        api: Api.Agent,
      },
      {
        ...requestOptions,
        parser: data => parseOkResponseFromJSON(data, {
    contentParser: parseChatSessionFromJSON,
    isContentArray: false,
  }),
      },
    );
  }

  /**
   * @description <p>🔐 Auth</p><p>🛡 CustomerAuth</p><p>🛡 ChatAccessAuth</p>
   *
   * @tags ChatSessionApi
   * @name ChatSessionApiDeleteChatSession
   * @summary Delete a chat session
   * @request DELETE:/customers/{customerId}/chat-sessions/{sessionId}
   * @secure
   */
  deleteChatSession(
    {
      customerId,
      sessionId,
    },
    requestOptions = {},
  ) {
    return this._request(
      {
        path: `/customers/${customerId}/chat-sessions/${sessionId}`,
        route: '/customers/{customerId}/chat-sessions/{sessionId}',
        method: 'DELETE',
        api: Api.Agent,
      },
      {
        ...requestOptions,
        parser: data => parseOkResponseFromJSON(data, {
    isContentArray: false,
  }),
      },
    );
  }

  /**
   * @description <p>🔐 Auth</p><p>🛡 CustomerAuth</p><p>🛡 ChatAccessAuth</p>
   *
   * @tags ChatSessionApi
   * @name ChatSessionApiListMessages
   * @summary List messages in a session
   * @request GET:/customers/{customerId}/chat-sessions/{sessionId}/messages
   * @secure
   */
  listMessages(
    {
      customerId,
      sessionId,
    },
    requestOptions = {},
  ) {
    return this._request(
      {
        path: `/customers/${customerId}/chat-sessions/${sessionId}/messages`,
        route: '/customers/{customerId}/chat-sessions/{sessionId}/messages',
        method: 'GET',
        api: Api.Agent,
      },
      {
        ...requestOptions,
        parser: data => parseOkResponseFromJSON(data, {
    contentParser: parseChatMessageFromJSON,
    isContentArray: true,
  }),
      },
    );
  }

  /**
   * @description <p>🔐 Auth</p><p>🛡 CustomerAuth</p><p>🛡 ChatAccessAuth</p>
   *
   * @tags ChatSessionApi
   * @name ChatSessionApiRateMessage
   * @summary Rate a message
   * @request PUT:/customers/{customerId}/chat-sessions/{sessionId}/messages/{messageUuid}/rating
   * @secure
   */
  rateMessage(
    {
      customerId,
      sessionId,
      messageUuid,
    },
    data,
    requestOptions = {},
  ) {
    return this._request(
      {
        path: `/customers/${customerId}/chat-sessions/${sessionId}/messages/${messageUuid}/rating`,
        route: '/customers/{customerId}/chat-sessions/{sessionId}/messages/{messageUuid}/rating',
        method: 'PUT',
        body: parseChatMessageRatingToJSON(data),
        api: Api.Agent,
      },
      {
        ...requestOptions,
        parser: data => parseOkResponseFromJSON(data, {
    isContentArray: false,
  }),
      },
    );
  }

  /**
   * @description <p>🔐 Auth</p><p>🛡 CustomerAuth</p><p>🛡 ChatAccessAuth</p>
   *
   * @tags ChatSessionApi
   * @name ChatSessionApiCancelApproval
   * @summary Record that the human cancelled the pending approval card (for a faithful reload)
   * @request POST:/customers/{customerId}/chat-sessions/{sessionId}/approval/cancel
   * @secure
   */
  cancelApproval(
    {
      customerId,
      sessionId,
    },
    requestOptions = {},
  ) {
    return this._request(
      {
        path: `/customers/${customerId}/chat-sessions/${sessionId}/approval/cancel`,
        route: '/customers/{customerId}/chat-sessions/{sessionId}/approval/cancel',
        method: 'POST',
        api: Api.Agent,
      },
      {
        ...requestOptions,
        parser: data => parseOkResponseFromJSON(data, {
    isContentArray: false,
  }),
      },
    );
  }

  static ɵfac = function ChatSessionApi_Factory(t) { return new (t || ChatSessionApi)(i0.inject(DynamicEnvService), i0.inject(HttpClient)); };
  static ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({ token: ChatSessionApi, factory: ChatSessionApi.ɵfac, providedIn: 'root' });
}
